import request from "@/utils/request";

export function userInfo() {
    return request({
        url: '/app/user/info',
        method: 'post'
    })
}

export function userInfoBind() {
    return request({
        url: '/app/user/info-bind',
        method: 'post'
    })
}

export function userUpdate(data) {
    return request({
        url: '/app/user/update',
        method: 'post',
        data
    })
}

export function sendCode(data) {
    return request({
        url: '/auth2/send_code',
        method: 'post',
        data
    })
}

export function getDetail() {
    return request({
        url: '/app/user/add/get',
        method: 'get'
    })
}

export function saveDetail(data) {
    return request({
        url: '/app/user/add/save',
        method: 'post',
        data
    })
}

export function submitDetail(data) {
    return request({
        url: '/app/user/add/submit',
        method: 'post',
        data
    })
}

export function userCheckNotice(data) {
    return request({
        url: '/app/user/check-notice',
        method: 'post',
        data
    })
}

export function viewH5(type) {
    return request({
        url: '/app/renwei/view/h5',
        method: 'get',
        params: {type: type}
    })
}

export function checkService(name) {
    return request({
        url: '/app/user/check/service',
        method: 'get',
        params: {serviceName: name}
    })
}

export function bindPersonnel(data) {
    return request({
        url: '/app/user/bind_personnel',
        method: 'post',
        data
    })
}

export function bindPersonnelPreview(data) {
    return request({
        url: '/app/user/bind_personnel_preview',
        method: 'post',
        data
    })
}
